var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V1000H1000V0Z",
    fill: "#FFFAF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9 634.7V665.6H182",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7 665.6H243.9V634.7",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8 665.601H212.9V696.501H274.8V665.601Z",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4 727.5H243.9V696.5H305.7",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182 696.5H243.9V727.5H193.7",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9 665.601H212.9V696.501H182",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.4 696.501H274.8V665.601H296.2",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.6 441.4V472.3H879.5",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.8 472.3H817.6V441.4",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.686 503.329L848.586 503.329L848.586 472.429L786.686 472.429L786.686 503.329Z",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.1 534.201H817.6V503.301H755.8",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.5 503.301H817.6V534.201H867.8",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.6 472.301H848.6V503.301H879.5",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.1 503.301H786.7V472.301H765.3",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 307.9C617.928 307.9 643 282.828 643 251.9C643 220.972 617.928 195.9 587 195.9C556.072 195.9 531 220.972 531 251.9C531 282.828 556.072 307.9 587 307.9Z",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 201.601V207.001",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 296.7V302.1",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.3 251.9H631.9",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.2 251.9H536.7",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 256.4C589.485 256.4 591.5 254.386 591.5 251.9C591.5 249.415 589.485 247.4 587 247.4C584.515 247.4 582.5 249.415 582.5 251.9C582.5 254.386 584.515 256.4 587 256.4Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 251.9L611.2 222",
    stroke: "#E5E5E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.8 236.9L587 251.9",
    stroke: "#E5E5E5",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.1 252.9H135.8V378.2H259.1V252.9Z",
    stroke: "#E5E5E5",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.894 358.916L241.894 272.416H152.994V358.916H241.894Z",
    stroke: "#E5E5E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.8 213H289.2V290.8H397.8V213Z",
    stroke: "#E5E5E5",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.891 274.811V228.911H305.191V274.811H381.891Z",
    stroke: "#E5E5E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.847 412.719V340.119H305.147V412.719H352.847Z",
    stroke: "#E5E5E5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.8 324.2H289.2V428.7H368.8V324.2Z",
    stroke: "#E5E5E5",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.8 784.2H841.7",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.3 784.2H820.8",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 784.2H788.3",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 784.2H452",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5 784.2H178.5",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5 784.2H138.5",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.9 674.4C312.7 662.8 280.6 642.4 266.7 600C257 570.4 256.8 533.2 267.2 529.7C279.3 525.7 300.4 568.5 308.1 564.8C314.2 561.9 301.5 535.4 299.8 490.5C298.6 459.9 303 433.6 316.8 410.2C323.1 399.5 327.7 391.6 332.8 392.2C353.7 394.6 347.8 536.2 370.1 538.9C380.6 540.2 389 509.7 400.8 512.2C410.8 514.3 417.5 539 419.3 555C419.4 555.8 419.5 556.4 419.5 556.9C424.7 608.8 394.4 646.2 384.2 658.9C368.9 677.7 358.6 681.5 350.6 681.6C342.2 681.5 335.8 677.6 330.9 674.4Z",
    fill: "#6DCCA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5 477C329 514 350 570.3 353.1 618C355.1 649.1 353.2 676.5 350.1 699",
    stroke: "#465172",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 784.2H267C251.4 756.6 252 722.7 268.5 695.7L291.3 658.4H397.6L419.7 692.9C436.1 718.4 438 750.7 424.9 778L422 784.2Z",
    fill: "#2359B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 561.9C375 561.9 374.6 578.9 351.2 601",
    stroke: "#465172",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1 601C301.1 601 316.8 633 353.9 633",
    stroke: "#465172",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M382.3 684.8C382.3 684.8 405.9 700.2 405.9 737.1",
    stroke: "#1E2A54",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6 794C523.6 823.2 573.5 847 635 847C683.2 847 724.2 832.5 739.7 812.1L623.2 820.5L523.6 794Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.7 791.1C720.8 790.5 717.7 790.8 715 791.9C697.4 798.8 666.6 803.4 631.6 803.4C576.9 803.4 532.6 792.2 532.6 778.4C532.6 766.2 567.3 756 613.2 753.8L616.4 737.1C553.5 741 505.7 760.5 505.7 783.9C505.7 810.1 565.7 831.4 639.7 831.4C672.1 831.4 701.8 827.3 725 820.5C740 816 739.1 794.3 723.7 791.1Z",
    fill: "#F78A21"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M671.1 801.3L719.1 790.8C719.1 790.8 731.7 792.1 734 798.8C738 810.2 729.8 817.2 729.8 817.2C729.8 817.2 726.7 790.8 671.1 801.3Z",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.7 791.1C720.8 790.5 717.7 790.8 715 791.9C697.4 798.8 666.6 803.4 631.6 803.4C576.9 803.4 532.6 792.2 532.6 778.4C532.6 766.2 567.3 756 613.2 753.8L616.4 737.1C553.5 741 505.7 760.5 505.7 783.9C505.7 810.1 565.7 831.4 639.7 831.4C672.1 831.4 701.8 827.3 725 820.5C740 816 739.1 794.3 723.7 791.1Z",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.3 439.9C698.3 434.8 680.6 431.9 662.1 431.9C643.7 431.9 626.2 434.7 610.2 439.7C600.5 417 587.3 398.5 573.4 387C571.2 385.2 567.9 385.8 566.5 388.3C538.8 438.4 526.4 495.7 531.6 558.2C536.4 628 563.3 704.7 588.8 784H735.6C761.2 704.8 787.8 628.9 792.8 560C798.3 497.1 785.7 439.6 757.2 389C755.8 386.5 752.5 385.9 750.3 387.7C736.7 399.3 723.8 417.5 714.3 439.9Z",
    fill: "#F78A21"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M674.4 533.9C674.4 537.6 668.9 540.6 662 540.6C655.2 540.6 649.6 537.6 649.6 533.9L662.1 531.1L674.4 533.9Z",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M713.3 782.6C713.3 782.6 713.3 774.7 714.8 768.1C728 709.4 719.3 691.3 719.3 691.3L691.5 782.8L713.3 782.6Z",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M608.8 782.6C608.8 782.6 608.8 774.7 607.3 768.1C594.1 709.4 602.8 691.3 602.8 691.3L630.6 782.8L608.8 782.6Z",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.3 439.9C698.3 434.8 680.6 431.9 662.1 431.9C643.7 431.9 626.2 434.7 610.2 439.7C600.5 417 587.3 398.5 573.4 387C571.2 385.2 567.9 385.8 566.5 388.3C538.8 438.4 526.4 495.7 531.6 558.2C536.4 628 563.3 704.7 588.8 784H735.6C761.2 704.8 787.8 628.9 792.8 560C798.3 497.1 785.7 439.6 757.2 389C755.8 386.5 752.5 385.9 750.3 387.7C736.7 399.3 723.8 417.5 714.3 439.9Z",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.6 487.8C625.018 487.8 628.6 484.218 628.6 479.8C628.6 475.382 625.018 471.8 620.6 471.8C616.182 471.8 612.6 475.382 612.6 479.8C612.6 484.218 616.182 487.8 620.6 487.8Z",
    fill: "#A83727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.6 487.8C708.018 487.8 711.6 484.218 711.6 479.8C711.6 475.382 708.018 471.8 703.6 471.8C699.182 471.8 695.6 475.382 695.6 479.8C695.6 484.218 699.182 487.8 703.6 487.8Z",
    fill: "#A83727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.8 506.699C664.4 506.299 660 506.299 655.6 506.699C653.5 506.899 652.8 508.999 654.4 510.099C655.8 510.999 657.2 511.899 658.6 512.899C660.6 514.299 663.9 514.299 665.9 512.899C667.3 511.899 668.7 510.999 670.1 510.099C671.6 508.999 670.8 506.899 668.8 506.699Z",
    fill: "#A83727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.1 694.199C717.4 723.699 703.7 754.699 694.3 784.199C684.6 784.199 662.1 784.199 662.1 784.199L662.3 701.099",
    fill: "#F78A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 694.199C606.7 723.699 623.4 754.699 632.8 784.199C642.5 784.199 662 784.199 662 784.199L661.8 701.099",
    fill: "#F78A21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.5 532.999C678.7 533.999 676.5 534.599 674.3 534.599C667.6 534.599 662.2 529.699 662.2 523.699",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.7 532.999C645.5 533.999 647.7 534.599 649.9 534.599C656.6 534.599 662 529.699 662 523.699",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.1 694.199C717.4 723.699 700.7 754.699 691.3 784.199C681.6 784.199 662.1 784.199 662.1 784.199L662.3 701.099",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605 694.199C606.7 723.699 620.4 754.699 629.8 784.199C639.5 784.199 662 784.199 662 784.199L661.8 701.099",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M729.1 451.399C736.5 428.699 747.3 422.899 747.3 422.899C747.3 422.899 755.1 425.799 755.1 456.699",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M595.1 451.399C587.7 428.699 576.9 422.899 576.9 422.899C576.9 422.899 569.1 425.799 569.1 456.699",
    fill: "#9B463D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.3 772.199L646.8 783.499",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.9 772.199L677.4 783.499",
    stroke: "#A83727",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M707 528.7C719.1 531.9 731.6 532.5 743.6 530.7",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M703.6 536.3C714.6 543.3 726 548.1 737 550.6",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M707 517.9C716.9 517.2 727.1 514.5 737 509.8",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M617.2 528.7C605.1 531.9 592.6 532.5 580.6 530.7",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M620.6 536.3C609.6 543.3 598.2 548.1 587.2 550.6",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M617.2 517.9C607.3 517.2 597.1 514.5 587.2 509.8",
    stroke: "#A83727",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.0b7e5f8f15797c37f921e4045967cbbc.svg";
export { ForwardRef as ReactComponent };